var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_66882",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0102539,
    y: 0.240234,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_66882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4038 13.0961C12.7051 13.0961 12.1137 12.8541 11.6298 12.3701C11.1458 11.8862 10.9038 11.2948 10.9038 10.5961C10.9038 9.89742 11.1458 9.30609 11.6298 8.82213C12.1137 8.33816 12.7051 8.09617 13.4038 8.09617C14.1025 8.09617 14.6938 8.33816 15.1778 8.82213C15.6617 9.30609 15.9037 9.89742 15.9037 10.5961C15.9037 11.2948 15.6617 11.8862 15.1778 12.3701C14.6938 12.8541 14.1025 13.0961 13.4038 13.0961ZM6.30762 17.1923C5.81052 17.1923 5.38497 17.0153 5.03095 16.6613C4.67695 16.3073 4.49995 15.8817 4.49995 15.3846V5.80768C4.49995 5.31058 4.67695 4.88502 5.03095 4.531C5.38497 4.177 5.81052 4 6.30762 4H20.4999C20.997 4 21.4226 4.177 21.7766 4.531C22.1306 4.88502 22.3076 5.31058 22.3076 5.80768V15.3846C22.3076 15.8817 22.1306 16.3073 21.7766 16.6613C21.4226 17.0153 20.997 17.1923 20.4999 17.1923H6.30762ZM7.8076 15.6923H18.9999C18.9999 15.1936 19.1769 14.7676 19.5309 14.4144C19.8849 14.0612 20.3105 13.8846 20.8076 13.8846V7.30765C20.3089 7.30765 19.8829 7.13065 19.5297 6.77665C19.1765 6.42263 18.9999 5.99708 18.9999 5.49998H7.8076C7.8076 5.99869 7.6306 6.42465 7.2766 6.77785C6.92258 7.13105 6.49703 7.30765 5.99993 7.30765V13.8846C6.49864 13.8846 6.9246 14.0616 7.2778 14.4156C7.631 14.7696 7.8076 15.1952 7.8076 15.6923ZM18.3268 20.6922H2.80768C2.31056 20.6922 1.885 20.5152 1.531 20.1612C1.177 19.8072 1 19.3816 1 18.8845V7.98078H2.49995V18.8845C2.49995 18.9615 2.53201 19.032 2.59613 19.0961C2.66023 19.1602 2.73074 19.1923 2.80768 19.1923H18.3268V20.6922ZM6.30762 15.6923H5.99993V5.49998H6.30762C6.22429 5.49998 6.15218 5.53043 6.09128 5.59133C6.03038 5.65223 5.99993 5.72434 5.99993 5.80768V15.3846C5.99993 15.4679 6.03038 15.54 6.09128 15.6009C6.15218 15.6618 6.22429 15.6923 6.30762 15.6923Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.f3f70c5cd74c5a249b7dcd0ffb15a723.svg";
export { ForwardRef as ReactComponent };